import styled, { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { themeGet } from 'modules/tetrisTheme';
const sizeToHeight = {
    sm: pxToRem(32),
    md: pxToRem(40),
};
const sizeToFontSize = {
    sm: themeGet('fontSize.small'),
    md: themeGet('fontSize.medium'),
};
export const Input = styled.input `
  border: none;
  background-color: transparent;
  width: 100%;
  font-size: inherit;
  line-height: ${themeGet('lineHeight.default')};
  color: ${themeGet('colors.text.300')};

  &[type='search']::-webkit-search-decoration,
  &[type='search']::-webkit-search-cancel-button,
  &[type='search']::-webkit-search-results-button,
  &[type='search']::-webkit-search-results-decoration {
    display: none;
  }

  &:focus-visible {
    outline: none;
  }

  &:disabled {
    color: ${themeGet('colors.disabled.200')};
  }
`;
export const Adornment = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
const outlineInputDisabledStyles = css `
  box-shadow: none;
  border: ${pxToRem(1)} dashed ${themeGet('colors.disabled.200')};
`;
const outlineInputDefaultStyles = css `
  box-shadow: 0 0 0 ${pxToRem(1)} ${themeGet('colors.border.100')}; /* firefox fallback until :has selector is supported */

  &:has(input:not(:disabled)) {
    box-shadow: 0 0 0 ${pxToRem(1)} ${themeGet('colors.border.100')};
  }

  &:hover:not(:has(input:disabled)) {
    box-shadow: 0 0 0 ${pxToRem(2)} ${themeGet('colors.border.100')};
  }

  &:has(input:focus-visible:not(:disabled)) {
    background-color: ${themeGet('colors.background.50')};
    box-shadow: 0 0 0 ${pxToRem(2)} ${themeGet('colors.border.300')};

    ${Adornment} svg {
      color: ${themeGet('colors.text.100')};
    }
  }

  &:has(input:active:not(:disabled)) {
    box-shadow: 0 0 0 ${pxToRem(2)} ${themeGet('colors.border.300')};
  }

  &:has(input:disabled) {
    ${outlineInputDisabledStyles};
  }
`;
const outlineInputInvalidStyles = css `
  box-shadow: 0 0 0 ${pxToRem(1)} ${themeGet('colors.text.danger')};

  &:hover:not(:has(input:disabled)) {
    box-shadow: 0 0 0 ${pxToRem(2)} ${themeGet('colors.text.danger')};
  }

  &:has(input:focus-visible:not(:disabled)) {
    background-color: ${themeGet('colors.background.50')};
    box-shadow: 0 0 0 ${pxToRem(2)} ${themeGet('colors.text.danger')};

    ${Adornment} svg {
      color: ${themeGet('colors.text.100')};
    }
  }

  &:has(input:active:not(:disabled)) {
    box-shadow: 0 0 0 ${pxToRem(2)} ${themeGet('colors.text.danger')};
  }

  &:has(input:disabled) {
    ${outlineInputDisabledStyles};
  }
`;
export const InputContainer = styled.div `
  min-width: 0;
  height: ${({ $size }) => sizeToHeight[$size]};
  font-size: ${({ $size }) => sizeToFontSize[$size]};
  box-sizing: border-box;
  position: relative;
  width: ${(props) => props.$stretch && '100%;'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: ${themeGet('spacing.lg')};
  padding: ${themeGet('spacing.md')} ${themeGet('spacing.lg')};
  border-radius: ${themeGet('borderRadius.md')};
  ${(props) => !props.$invalid && outlineInputDefaultStyles};
  ${(props) => props.$invalid && outlineInputInvalidStyles};
  transition: box-shadow 0.15s;
`;
